:host {
  display: block;

  .av-pin {
    position: relative;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color:var(--av-card-color);

    // &.av-pin-dark input {
    //   color: white;
    // }

    input {
      margin: 0 2px;
      font-size: 2em;
      text-align: center;
      font-weight: normal;
      border-bottom: 0;
      margin: 0 2px;
      border-radius: var(--av-form-input-border-radius);
      padding: 5px;
      background-color: var(--av-card-form-input-background-color);
      color: var(--av-card-color);
      border: 1px solid var(--av-color-accent);
    }

    .av-pin-countdown {
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }

  input {
    @include form-input;
  }
}

// .av-card.av-card-dark .av-pin input {
//   background-color: $option-panel-bkg;
// }
